/* eslint-disable @typescript-eslint/ban-types */
import { Autocomplete, AutocompleteCloseReason } from "@material-ui/lab";
import { ChevronDown } from "react-feather";
import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(theme => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  sectionTitle: {
    margin: theme.spacing(0, 0, 2, 0),
  },
  title: {
    padding: theme.spacing(0),
    marginBottom: theme.spacing(2),
  },
  subTitle: {
    fontWeight: 300,
    fontSize: "15px",
  },
  autocomplete: {
    marginTop: theme.spacing(2),
  },
  autocompleteInput: {},
}));

interface AdditionalLanguagesMultiSelectProps {
  values: string[];
  additionalLanguageOptions: string[];
  onAdditionalLanguageChange: (newValues: string[]) => void;
}

const AdditionalLanguagesMultiSelect: React.FC<AdditionalLanguagesMultiSelectProps> = ({
  values,
  additionalLanguageOptions,
  onAdditionalLanguageChange,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClose = (
    event: React.ChangeEvent<{}>,
    reason: AutocompleteCloseReason,
  ) => {
    if (reason !== "select-option") {
      setOpen(false);
    }
  };

  return (
    <Autocomplete
      className={classes.autocomplete}
      disableClearable
      forcePopupIcon={false}
      id="additional-languages-autocomplete"
      multiple
      onChange={(_event, newValues) => {
        onAdditionalLanguageChange(newValues);
      }}
      options={additionalLanguageOptions}
      open={additionalLanguageOptions.length > 0 && open}
      onOpen={() => setOpen(true)}
      onClose={handleClose}
      getOptionLabel={option => option}
      getOptionSelected={(option, value) => option === value}
      ListboxProps={{
        ["data-test"]: "additional-languages-list",
      }}
      ChipProps={{
        ["data-test"]: "additional-languages-chip",
      }}
      renderInput={params => (
        <TextField
          {...params}
          className={classes.autocompleteInput}
          label="Additional languages spoken"
          variant="outlined"
          placeholder="Select"
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            // We have to manually spread these InputProps otherwise the autocomplete won't work :/
            ...params.InputProps,
            endAdornment: (
              <InputAdornment position="end">
                <ChevronDown />
              </InputAdornment>
            ),
            // @ts-ignore
            ["data-test"]: "additional-languages-input",
          }}
        />
      )}
      value={values}
    />
  );
};

export default AdditionalLanguagesMultiSelect;
